var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetInventoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.224121,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3F46AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3343_6375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.22412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3343_6375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 18.2241C11.2833 18.2241 11.5208 18.1283 11.7125 17.9366C11.9042 17.745 12 17.5075 12 17.2241C12 16.9408 11.9042 16.7033 11.7125 16.5116C11.5208 16.32 11.2833 16.2241 11 16.2241C10.7167 16.2241 10.4792 16.32 10.2875 16.5116C10.0958 16.7033 10 16.9408 10 17.2241C10 17.5075 10.0958 17.745 10.2875 17.9366C10.4792 18.1283 10.7167 18.2241 11 18.2241ZM11 14.2241C11.2833 14.2241 11.5208 14.1283 11.7125 13.9366C11.9042 13.745 12 13.5075 12 13.2241C12 12.9408 11.9042 12.7033 11.7125 12.5116C11.5208 12.32 11.2833 12.2241 11 12.2241C10.7167 12.2241 10.4792 12.32 10.2875 12.5116C10.0958 12.7033 10 12.9408 10 13.2241C10 13.5075 10.0958 13.745 10.2875 13.9366C10.4792 14.1283 10.7167 14.2241 11 14.2241ZM14 18.2241H21C21.2833 18.2241 21.5208 18.1283 21.7125 17.9366C21.9042 17.745 22 17.5075 22 17.2241C22 16.9408 21.9042 16.7033 21.7125 16.5116C21.5208 16.32 21.2833 16.2241 21 16.2241H14C13.7167 16.2241 13.4792 16.32 13.2875 16.5116C13.0958 16.7033 13 16.9408 13 17.2241C13 17.5075 13.0958 17.745 13.2875 17.9366C13.4792 18.1283 13.7167 18.2241 14 18.2241ZM14 14.2241H21C21.2833 14.2241 21.5208 14.1283 21.7125 13.9366C21.9042 13.745 22 13.5075 22 13.2241C22 12.9408 21.9042 12.7033 21.7125 12.5116C21.5208 12.32 21.2833 12.2241 21 12.2241H14C13.7167 12.2241 13.4792 12.32 13.2875 12.5116C13.0958 12.7033 13 12.9408 13 13.2241C13 13.5075 13.0958 13.745 13.2875 13.9366C13.4792 14.1283 13.7167 14.2241 14 14.2241ZM8 23.2241C7.45 23.2241 6.97917 23.0283 6.5875 22.6366C6.19583 22.245 6 21.7741 6 21.2241V9.22412C6 8.67412 6.19583 8.20329 6.5875 7.81162C6.97917 7.41995 7.45 7.22412 8 7.22412H24C24.55 7.22412 25.0208 7.41995 25.4125 7.81162C25.8042 8.20329 26 8.67412 26 9.22412V21.2241C26 21.7741 25.8042 22.245 25.4125 22.6366C25.0208 23.0283 24.55 23.2241 24 23.2241H20V24.2241C20 24.5075 19.9042 24.745 19.7125 24.9366C19.5208 25.1283 19.2833 25.2241 19 25.2241H13C12.7167 25.2241 12.4792 25.1283 12.2875 24.9366C12.0958 24.745 12 24.5075 12 24.2241V23.2241H8ZM8 21.2241H24V9.22412H8V21.2241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetInventoryIcon);
export default __webpack_public_path__ + "static/media/Asset_Inventory_icon.1a28033d2b946dfa8c6eca7373ef6343.svg";
export { ForwardRef as ReactComponent };